import React from 'react'
import { InterpretationPunchRuleTable } from 'components/table/interpretation_rule/InterpretationPunchRuleTable'

const InterpretationPunchRule = () => {
    return (
        <>
            <InterpretationPunchRuleTable/>
        </>
    )
}

export { InterpretationPunchRule }